import { useTranslation } from "react-i18next";
import { Typography } from "~/common/mui";
import * as PriceUtils from "~/utils/PriceUtils";

export const TariffSurchargeAsterisk = () => {
  const { t } = useTranslation();
  return <Typography color="textLabel">{t("price.tariff.surcharge.applicable")}</Typography>;
};
export const IncludedSurchargeAsterisk = ({ value, percent }: { value?: PriceData; percent?: number }) => {
  const { t } = useTranslation();

  if (!value) {
    return null;
  }

  const label = t("cart.param.includedSurcharge");
  let text;
  if (percent && percent > 0) {
    text = `${PriceUtils.text2(value, "-")} (${percent * 100}%)`;
  } else {
    text = PriceUtils.text2(value, "-");
  }
  return <Typography color="textLabel">{`${label} ${text}`}</Typography>;
};
